<template>
  <div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <div class="button is-primary" @click="saveData">저장하기</div>
    </div>

    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="서비스 가이드 등록/수정">
            <div class="columns is-multiline">
              <div class="column is-5">
                <admin-form-item label="서비스 가이드 제목*">
                  <input class="input"
                        :value="guide.title"
                        @input="e => guide.title = e.target.value"
                        placeholder="서비스 가이드 제목을 입력하세요."
                        type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="서비스 가이드 이미지">
                  <div class="description-text">
                    가이드 이미지를 순서대로 업로드 해주세요. <br>
                    이미지 비율은 <span style="color:#ff5722;">9:16</span> 입니다.
                  </div>
                  <div class="flex">
                    <div v-for="(img, idx) in guide.imgs" :key="'guide-'+idx" class="flex align-center">
                      <input-img style="display: inline-block;" :key="'img'+idx"
                                class="item"
                                :idx="(idx+1)*111154"
                                @addImg="guide.imgs.push('')"
                                :url.sync="guide.imgs[idx]"></input-img>
                      <!-- <input class="input"
                            :value="linkValue(idx)"
                            @input="e=>inputLink(e, idx)"
                            placeholder="서비스 가이드를 누르면 이동할 경로를 입력해주세요."
                            type="text"> -->
                    </div>
                    <div class="lp-add-img" @click="addImg">
                      <i class="material-icons">add</i>
                    </div>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="서비스 가이드 노출여부">
                  <div class="flex" style="flex-wrap:wrap">
                    <lp-check-bool
                      label="노출 여부"
                      :checkedVal.sync="guide.visible"
                      ></lp-check-bool>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <div class="button is-primary" @click="saveData">저장하기</div>
    </div>

  </div>
</template>

<script>
import draggable from 'vuedraggable'
import moment from "moment";
import BreadCrumb from "../../module/common/BreadCrumb";
import LpInputText from "../../module/common/LpInputText";
import LpRadio from "../../module/common/LpRadio";
import InputImg from "../../module/common/InputImg";
import LpAddress from "../../module/common/LpAddress";
import LpAdmDropInput from "../../module/common/LpAdmDropInput";
import LpCheckBool from "../../module/common/LpCheckBool";
import LpSortDropDown from "../../module/common/LpSortDropDown";
import ProductList from '../product/ProductList';
import { SweetModal } from 'sweet-modal-vue';

export default {
  layout: "Main",
  components: {
    LpInputText,
    draggable,
    LpRadio,
    InputImg,
    LpAddress,
    LpAdmDropInput,
    SweetModal,
    ProductList,
    LpCheckBool,
    LpSortDropDown
  },
  created() {
    this.getData();
  },
  data() {
    return {
      // 서비스 가이드 정보
      guide: {
        id: 0,
        imgs: [''],
        links: [''],
        title: '',
        visible: true
      }
    }
  },
  methods: {
    addImg() {
      this.guide.imgs.push('');
      this.guide.links.push('');
    },
    linkValue(idx) {
      return this.guide.links[idx];
    },
    inputLink(e, idx) {
      this.guide.links[idx] = e.target.value;
    },
    imgField(img) {
      return 'background-image: url('+this.image(img)+');' +
        ' width: 60px; height: 60px; background-size: cover;' +
        ' background-position: center;';
    },
    // 서비스 가이드 등록 상품 검색
    openSelectProduct(){
      /*let value = {
        productTable: this.productTable,
        productIdArr: this.guide.products
      }
      this.$store.commit('openModal', {type: 'modal-select-exhibition-product', value: value, width: '1080'})*/
      this.$modal.show('productListModal');
    },
    deleteProductItem(idx){
      removeIndex(this.productTable, idx);
      removeIndex(this.guide.products, idx);
      removeIndex(this.id_list, idx);
    },
    saveData() {
      let err = '';
      if(!this.guide.title) {
        err = '서비스 가이드 제목을 입력해주세요.';
      }

      if(err) {
        this.toast(err);
        return;
      }

      let value = this.cloneItem(this.guide);
      if(this.$route.query.id){
        this.$axios.patch(this.getUrl('guide/')+this.$route.query.id, value).then(res=>{
          if(res.status===200){
            this.toast('저장되었습니다.');
            this.$router.replace(this.getPath('guide'));
          }
        })
      }
      else{
        this.$axios.post(this.getUrl('guide'), value).then(res=>{
          if(res.status===200){
            this.toast('저장되었습니다.');
            this.$router.replace(this.getPath('guide'));
          }
        })
      }
    },
    // 뒤로가기 (등록 취소)
    clickBack() {
      this.$router.back();
    },
    getData(){
      if(this.$route.query.id){
        this.$axios.get(this.getUrl('guide/'+this.$route.query.id)).then(res=>{
          if(res.status===200){
            this.guide = res.data;
            this.productTable = res.data.product_list;

            for(let i=0; i<res.data.product_list.length; i++){
              this.id_list.push(res.data.product_list[i].id);
            }
          }
        })
      }
    }
  }
};
</script>

<style lang="stylus" type="stylus" scoped>
////@import '~assets/css/reset';
@import '~assets/css/lp_variable';
//@import '~assets/css/lp_main';

.tr-whole-border th
  padding 12px 6px

.many-field-tr td
  padding 6px

.user-reg-basic-group-1 {
  width: 50%;
}

.user-reg-basic-group-2 {
  width: 50%;
  margin-top: 137px;
}

.user-reg-content-service {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.user-reg-service-group {
  width: 50%;
  padding-left: 20px;
  margin-bottom: 12px;
}

.user-reg-history-memo {
  width: 380px;
  height: 240px;
  margin: 0 10px;
  font-size: 0.9rem;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 12px;
  overflow-y: auto;
}

.history-memo-item {
  width: 100%;
  margin-bottom: 12px;
}

.user-reg-history-btn {
  background-color: $primary;
  color: #fff;
  display: inline-block;
  padding: 8px 12px;
  margin-left: 8px;
  border-radius: 3px;
  cursor: pointer;
}

.prod-search-btn {
  font-size: 0.8rem;
  background: #e6e6e6;
  padding: 6px 12px;
  border-radius: 3px;
  display: inline-block;
  cursor: pointer;
}

.prod-tag
  background-color $point
  display inline-block
  padding 4px 10px
  color #fff
  border-radius 3px
  margin 2px

.prod-detail-content
  padding 20px
  font-size .95rem
  color #222
  border-radius 3px
  border none
  background-color #f2f7f8
  display block
  width 100%
  max-width 900px
  height 120px

.comment-sub-title
  background #ddd
  color #333
  padding 8px 16px
  font-size .95rem
  border-radius 3px
  display flex
  justify-content space-between

.description-text
  font-size 11px
  color #989898
  padding-bottom 12px

</style>
